import axios from "axios";
import store from "../../../store/store";
import { setupAxios } from "../../../utils/setupAxios";
import { notificationEmitter } from "../../../utils/notificationEmitter";

const interceptor = axios.create();

// Dashboard and legacy petitions share the same session and refresh queue as
// the main axios client. Only redux-persist writes the persisted auth format.
setupAxios(interceptor, store);

interceptor.interceptors.response.use(
  response => response,
  error => {
    // Handle 403 Forbidden errors (insufficient permissions)
    if (error.response && error.response.status === 403) {
      // Show notification with the error message from the API
      const message = error.response.data?.message || 'You do not have permission to perform this action';
      notificationEmitter.showError('Access Denied', message);

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default interceptor;
